import { Component, inject, OnInit } from '@angular/core';
import { GlobalPageHeaderComponent } from '../../../../../../../components/global-page-header/global-page-header.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { NlToBrPipe } from '../../../../../../../pipes/nl-to-br.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { getTemperatureType } from '../../../../../helper/temperature';

@Component({
  selector: 'app-p0003606-espinstallation-ph',
  templateUrl: './p0003606-espinstallation-ph.component.html',
  styleUrls: ['./p0003606-espinstallation-ph.component.scss'],
  standalone: true,
  imports: [
    GlobalPageHeaderComponent,
    IonButton,
    IonContent,
    NlToBrPipe,
    TranslatePipe,
  ],
})
export class P0003606ESPInstallationPhComponent {
  private modalController: ModalController = inject(ModalController);

  constructor() {}

  async dismissModal() {
    await this.modalController.dismiss();
  }

  protected readonly getTemperatureType = getTemperatureType;
}
